var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('span',[_vm._v(_vm._s(_vm.startText)+" ")]),_c('span',{staticClass:"type_ib"},[_vm._v(" ~ "+_vm._s(_vm.endText))])])}
var staticRenderFns = []

export { render, staticRenderFns }